module.exports = __webpack_public_path__ + "static/media/mapView.2fd93ad6.svg";